import {HttpParams} from "@angular/common/http";
import {KeyByObject} from "../misc/reduce-helpers";

export function toString(value: any): string {
  if (value === null || value === undefined) value = "";
  if (typeof value === "string") return value;
  return `${value}`;
}

export function toNumber(value: any, replaceInvalid: number | undefined = undefined): number {
  if (typeof value === "number") return value;
  if (value === null || value === undefined || value === "") return replaceInvalid;

  const tmp = +value;

  return Number.isNaN(tmp) ? replaceInvalid : tmp;
}

export function toBoolean(value: any, defaultIfUndefined = false): boolean {
  if (value === undefined) return defaultIfUndefined;
  if (typeof value === "boolean") return value;
  if (typeof value === "string" && /^(?:true|[1-9][0-9]+)$/i.test(value)) return true;
  if (typeof value === "string" && /^(?:false|0)$/i.test(value)) return false;

  return !!value;
}

export function toList<T, U>(converter: (obj: U) => T, value: any|U[]): T[] {
  if (!Array.isArray(value)) return [] as T[];
  return Array.prototype.map.call(value, converter);
}

export function toFlags(value: any): {[key: string]: boolean} {
  if (!Array.isArray(value)) return {};

  return Array.prototype.map.call(value, toString)
    .reduce((obj, key) => obj.add(key, true), new KeyByObject<boolean>())
    .toObject();
}

export function toHttpParams(object: {[key: string]: any}): HttpParams {
  const sanitized = {};

  for (const [param, value] of Object.entries(object)) {
    if (Array.isArray(value)) {
      sanitized[param] = toList(toString, value);
    } else {
      sanitized[param] = toString(value);
    }
  }

  return new HttpParams({fromObject: sanitized});
}

export function toDate(object: any): Date {
  if (object === null || object === undefined) return undefined;
  if (object instanceof Date) return object;

  switch (typeof object) {
    case "number":
      return new Date(object);
    case "string":
      if (/^[-]?[0-9]+$/.test(`${object}`)) return new Date(+object);
      try {
        return new Date(object);
      } catch (error) {
        console.warn(error);
      }
      return undefined;
    default:
      return undefined;
  }
}
